/* Kingswood: Shopify's cookie banner (#shopify-pc__banner, drawn by Shopify's own script from
   Settings > Customer privacy) says its piece in one short sentence instead of a paragraph. Only the
   sentence is replaced: the Privacy Policy link and the Accept / Decline / Manage preferences buttons are
   Shopify's own and untouched. The compact layout is in kw-luxe.css ("Shopify's cookie banner").
   English pages only; to change the wording edit TEXT. Loaded from layout/theme.liquid. */
(() => {
  const TEXT = 'We use cookies for personalization, ads and analytics. ';
  if (!/^en\b/i.test(document.documentElement.lang || 'en')) return;

  const shorten = () => {
    const p = document.querySelector('#shopify-pc__banner .shopify-pc__banner__body p');
    if (!p || p.dataset.kwShort) return;
    const link = p.querySelector('a');
    p.textContent = TEXT;
    if (link) p.appendChild(link);
    p.dataset.kwShort = '1';
  };

  /* The banner is added to <body> some time after load, and only where the visitor's region needs it */
  shorten();
  new MutationObserver(shorten).observe(document.body, { childList: true });
})();
